import React from 'react';
import styled from 'styled-components';
import voiture from "../assets/modern-electric-car.png";
import serviceCards from '../data/serviceCards'

const ServicesPage = () => {
    return (
        <ServicesContainer>
            {/* STRATÉGIE & CONCEPT */}
            <BackgroundText>STRATÉGIE & CONCEPT</BackgroundText>
            <ContentLayout>
                {/* Image de la voiture */}
                <CarImageContainer>
                    <CarImage src={voiture} alt="Voiture électrique design" />
                </CarImageContainer>

                {/* Texte principal */}
                <TextSection>
                    <MainHeading>
                    Transformer votre vision en solutions innovantes et performantes
                    </MainHeading>
                </TextSection>
            </ContentLayout>

            {/* ServicesSection */}
            <ServicesSection>

                <BackgroundStrategie>STRATÉGIE </BackgroundStrategie>
                <ServiceCards>
                    {serviceCards.map((card, index) => (
                        <ServiceCard key={index}>
                            <CardImageContainer>
                                <CardImage src={card.image} alt={card.title} />
                            </CardImageContainer>
                            <CardContent>
                                <CardNumber>{card.number}</CardNumber>
                                <CardTitle>{card.title}</CardTitle>
                                <CardDescription>
                                    {card.description}
                                </CardDescription>
                            </CardContent>
                        </ServiceCard>
                    ))}
                </ServiceCards>

                <CollaborationSection>

                    {/*  Line   */}
                    <TopLine>
                        <Line />
                    </TopLine>

                    <CollaborationTitle>
                        Intéressé par
                        une collaboration ?
                    </CollaborationTitle>
                    <GetInTouchButton href="/contact">
                        NOUS CONTACTER <Circle />
                    </GetInTouchButton>

                </CollaborationSection>
            </ServicesSection>


        </ServicesContainer>
    );
};

export default ServicesPage;

// Styles
const ServicesContainer = styled.div`
    min-height: 100vh;
    background: white;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const BackgroundText = styled.div`
    position: absolute;
    top: 5%;
    left: 2%;
    font-size: 1rem;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.3);
    text-transform: uppercase;
    letter-spacing: 0.2em;
    z-index: 0;

    @media (max-width: 768px) {
        font-size: 0.8rem;
        top: 2%;
        left: 5%;
    }
`;

const ContentLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    gap: 2rem;
    padding: 5rem;
    z-index: 1;

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
        padding: 2rem;
    }
`;

const CarImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

`;

const CarImage = styled.img`
    width: 80%;
    height: auto;
    max-width: 800px;
    object-fit: cover;

    @media (max-width: 1024px) {
        width: 100%;
    }
`;

const TextSection = styled.div`
  text-align: left;
  padding: 4rem;

    @media (max-width: 1024px) {
        padding: 2rem;
        text-align: center;
    }
`;

const MainHeading = styled.h1`
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 900;
    line-height: 1.2;
    margin: 0;
    color:  rgba(0, 0, 0, 0.8);

    @media (max-width: 768px) {
        font-size: clamp(2rem, 6vw, 3rem);
    }
`;


const BackgroundStrategie = styled.div`
  position: relative;
  left: 80%;
  transform: translate(-50%);
  font-size: 10vw; // Plus grand pour être plus visible
  font-weight: 900; // Plus épais
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
  text-transform: uppercase;
  letter-spacing: 1vw;
  opacity: 0.5;
  

`;

// ServicesSectionstyles
const ServicesSection = styled.section`
    padding: 4rem;
    margin-top: 4rem;

    @media (max-width: 768px) {
        padding: 2rem;
        margin-top: 2rem;
    }
`;

const ServiceCards = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
    margin-bottom: 4rem;
  

    @media (max-width: 1024px) {
        gap: 2rem;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const ServiceCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const CardImageContainer = styled.div`
    width: 100%;
    aspect-ratio: 16/9;
    overflow: hidden;
    background-color: #f5f5f5;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.9);
    border-radius: 8px;
`;

const CardImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
    }
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const CardNumber = styled.span`
    font-size: 1.2rem;
    font-weight: 600;
    color: #000;
    opacity: 0.5;
`;

const CardTitle = styled.h2`
    font-size: clamp(1.4rem, 2vw, 1rem);
    font-weight: 700;
    margin: 0;
    color: #000;
`;

const CardDescription = styled.p`
    font-size: 1rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.7);
    white-space: pre-line;
`;


// Divider 
const TopLine = styled.div`
  width: 100%;
  padding: 0;

  @media (max-width: 768px) {
    margin: 1rem 0 3rem;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: gray;
`;

const CollaborationSection = styled.div`
    margin-top: 2rem;
    padding: 4rem 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @media (max-width: 768px) {
        margin-top: 4rem;
        padding: 2rem 0;
    }
`;

const CollaborationTitle = styled.h2`
    font-size: clamp(2rem, 4vw, 3rem);
    font-weight: 700;
    color: #000;
`;

const GetInTouchButton = styled.a`
   width: fit-content;
   display: inline-flex;
   align-items: center;
   gap: 8px;
   text-decoration: none;
   color: #000;
   padding: 8px 0;
   font-size: 0.9rem;
   text-transform: uppercase;
   letter-spacing: 0.5px;
   cursor: pointer;
   position: relative;

   &:after {
       content: '';
       position: absolute;
       width: 100%;
       height: 1px;
       bottom: 0;
       left: 0;
       background-color: #000;
       transform: scaleX(0);
       transform-origin: bottom right;
       transition: transform 0.3s ease;
   }

   &:hover:after {
       transform: scaleX(1);
       transform-origin: bottom left;
   }
`;

const Circle = styled.span`
   display: inline-block;
   width: 6px;
   height: 6px;
   background-color: #000;
   border-radius: 50%;
   margin-left: 4px;
`;